import ApiService from "@/common/api.service";
import {
  ADD_FAVORITE_FORM,
  DELETE_FAVORITE_FORM,
  GET_LIST_FAVORITE
} from "./actions.type";
import { SET_LIST_FAVORITE, SET_ERROR_FAVORITE } from "./mutations.type";

const state = {
  errors: {},
  favorites: []
};
const getters = {
  favorites(state) {
    return state.favorites;
  }
};

const actions = {
  [GET_LIST_FAVORITE]({ commit }) {
    ApiService.get("v1/customers", "favorite?offset=0&limit=100")
      .then(response => {
        commit(SET_LIST_FAVORITE, response.data);
      })
      .catch(response => {
        commit(SET_ERROR_FAVORITE, response.data);
      });
  },
  [ADD_FAVORITE_FORM]({ dispatch, commit }, payload) {
    return ApiService.post("v1/customers/favorite", payload)
      .then(() => {
        dispatch(GET_LIST_FAVORITE);
      })
      .catch(response => {
        commit(SET_ERROR_FAVORITE, response.data);
      });
  },
  [DELETE_FAVORITE_FORM]({ dispatch, commit }, payload) {
    return ApiService.delete(`v1/customers/favorite/${payload}`)
      .then(() => {
        dispatch(GET_LIST_FAVORITE);
      })
      .catch(() => {
        commit(SET_ERROR_FAVORITE, response.data);
      });
  }
};

const mutations = {
  [SET_LIST_FAVORITE](state, payload) {
    state.favorites = payload;
  },
  [SET_ERROR_FAVORITE](state, payload) {
    state.errors = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
